import { ITableService } from 'src/app/common/interfaces/table/table-service.interface';
import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { IReturnInitiate } from '../../interfaces/return-list/return-initiate.interface';
import { IRtpInitiatedReturnList } from '../../interfaces/initiated-return/rtp-initiated-return-list.interface';
import { IRtpInitiatedReturnDetails } from '../../interfaces/initiated-return/rtp-initiated-return-detail.interface';

export abstract class AbstractRtpReturnInitiatedService extends ITableService {
  abstract tableFilterSingleRecordById(
    rtpUniqueMessageId: string
  ): Promise<IRtpInitiatedReturnList | undefined>;
  abstract getDetail(rtpUniqueMessageId: string): Promise<IRtpInitiatedReturnDetails | undefined>;
  abstract getDetailFromTransaction(
    rtpUniqueMessageId: string
  ): Promise<IRtpInitiatedReturnDetails | undefined>;
  abstract initiate(initiateReturn: IReturnInitiate): Promise<IWebMessage | undefined>;
  abstract reasonInitiateReturnList(rtpUniqueMessageId: string): Promise<any>;
  abstract fraudClassifierList(): Promise<any>;
}
